import React from 'react';
 
export type IPermissionValues = Partial<Record<string, boolean>>;

export interface IAppContextValue {
	permissions: IPermissionValues[] | null;
}

// Creating the context object and passing the default values.
const AppContext = React.createContext<IAppContextValue>({ permissions: null });
 
export default AppContext;